<template>
  <v-container fluid grid-list-xl class="pa-0">
    <div v-if="msgType=='success'">
      <v-alert
        :value="true"
        color="success"
        icon="check_circle"
        outline
        v-if="msg"
      >
        {{msg}}
      </v-alert>
    </div>
    <div v-if="msgType=='warning'">
      <v-alert
        :value="true"
        color="error"
        icon="priority_high"
        outline
        v-if="msg"
      >
        {{msg}}
      </v-alert>
    </div>
    <v-toolbar class="tow-clor-1 card-r shadow-1 text-white">
      <input
        multiple
        type="file"
        style="display:none"
        ref="ImgInput"
        accept="image/*"
        @change="onImgPicked"
      >
      <v-btn
        class="card-r white text-primary"
        flat
        @click="onPickImg"
      >Choose Images</v-btn>
      <input
        type="file"
        style="display:none"
        ref="VideoInput"
        accept="video/*"
        @change="onVideoPicked"
      >
      <v-btn
        class="card-r white text-primary"
        flat
        @click="onPickVideo"
      >Upload Video</v-btn>
    </v-toolbar>
    <v-layout row wrap class="">
      <v-flex lg12 xs12>
        <v-card class="card-r no-shadow">
          <v-layout row wrap>
            <v-flex lg3 xs3 class="pa-2" v-for="(n,index) in attachment.galleryURL" v-bind:key="index" xs4 d-flex>
              <v-card flat tile class="d-flex hover-styl">
                <v-img
                  :src="n"
                  :lazy-src="n"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </v-img>

                <div class="effect">
                  <v-btn icon round color="blue-grey" class="text-xs-right text-white right" @click="removeImage(index)"><v-icon>delete</v-icon></v-btn>
                  <!--<v-btn icon round color="blue-grey" class="text-xs-right text-white right"><v-icon>edit</v-icon></v-btn>-->
                </div>
              </v-card>
            </v-flex>
          </v-layout>
          <v-btn
            class="card-r"
            outline
            @click="uploadPics"
            v-if="attachment.galleries[0]"
          >Upload</v-btn>
        </v-card>
      </v-flex>

    </v-layout>
    <div>
      <v-layout>
        <v-flex xs12 sm12>
          <v-card class="card-r no-shadow">
            <v-container grid-list-sm fluid class="pa-0 pb-1">
              <v-layout row wrap>
                <v-flex
                  v-for="(n,index) in pics"
                  v-bind:key="index"
                  xs2
                  d-flex
                >
                  <v-card flat tile class="d-flex hover-styl" >
                    <v-img
                      :src="n.file_path"
                      aspect-ratio="1"
                      class="grey img lighten-2"
                    >
                      <v-layout
                        slot="placeholder"
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </v-img>
                    <div class="effect">
                      <v-btn icon small color="blue-grey" class="text-xs-right text-white right" @click="deleted = true">
                        <v-icon class="f-15">delete</v-icon></v-btn>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    <v-dialog v-model="deleted" max-width="290">
      <v-card class="card-r">
        <v-card-title class="f-20 text-capitalize">Are You Sure Want To Delete?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small class="grey text-white left card-r" text @click="deleted = false">No</v-btn>
          <v-btn small class="primary text-white card-r" text @click="removeImage(index)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  <!--<v-layout>-->
  <!--<v-flex>-->

  <!--<v-card  class="pa-4 invoice">-->
  <!--<v-layout xs12>-->
  <!--<v-flex xs12 class="text-lg-center">-->
  <!--<h1 class="pb-4">-->
  <!--Last Month Invoice-->
  <!--</h1>-->
  <!--</v-flex>-->
  <!--</v-layout>-->
  <!--<v-layout>-->

  <!--<v-flex  xs12 class="mt-3 mb-3">-->
  <!--<img class="invoice-logo " src="https://wallpaperaccess.com/full/128916.jpg" alt="logo">-->
  <!--</v-flex>-->
  <!--<v-flex xs12 class="mt-3">-->
  <!--<span>-->
  <!--<strong>Ms. Rani Rabukpotha,	 </strong><br>-->
  <!--Kuliyapitiya Road,	P. O. Box No. 875,-->
  <!--PANNALA (NWP) 60160-->
  <!--</span>-->
  <!--</v-flex>-->
  <!--</v-layout>-->
  <!--<v-divider ></v-divider>-->
  <!--<v-layout xs12 class="layout-invoice-contant">-->
  <!--<v-flex xs6 class="mt-3">-->
  <!--<span >Customer Name: <code> NAME</code></span><br><br>-->
  <!--<span >Subscription Number: <code> 1234</code></span><br><br>-->
  <!--<span >Validity Period: <code> DD/MM/YYYY</code> to <code>DD/MM/YYYY</code></span>-->
  <!--</v-flex>-->
  <!--<v-flex xs6 justify-center class="mt-3">-->
  <!--<v-flex xs6 justify-center class="mt-3">-->
  <!--<span>Amount Paid</span>-->
  <!--</v-flex>-->
  <!--<v-flex xs6 justify-center class="mt-3">-->
  <!--<span class="span">$15000</span>-->
  <!--</v-flex>-->
  <!--</v-flex>-->
  <!--</v-layout>-->

  <!--</v-card>-->
  <!--</v-flex></v-layout>-->
</template>
<script>
  /* eslint-disable */
  import { mapState , dispatch } from "vuex"
  export default {
    data: () => ({
      deleted: false,
      attachment: {
        galleries: [],
        galleryURL: [],
        photosURL: [],
        videos: [],
        videosURL: []
      },
      msg:'',
      msgType:'',
      gallary:''
    }),
    methods: {
      onPickLogo() {
        this.$refs.logoInput.click();
      },
      onPickImg(){
        this.$refs.ImgInput.click();

      },
      onPickVideo(){
        this.$refs.VideoInput.click();

      },
      onImgPicked(){
        const files = event.target.files;
        if(files.length==1){
          this.attachment.galleries.push(files[0])
        }else{
          for(var i=0;i<files.length;i++){
            this.attachment.galleries.push(files[i])
          }
        }
        for(var i=0;i<files.length;i++){
          let fileName = files[i].name;
          if (fileName.lastIndexOf(".") <= 0) {
            return alert("Please add a valid file! ");
          }
        }
        for(var i=0;i<files.length;i++){
          const fileReader = new FileReader();
          fileReader.readAsDataURL(files[i]);
          // var fileName
          fileReader.addEventListener("load", () => {
            this.attachment.galleryURL.push(fileReader.result);
          });
        }

      },
      onVideoPicked(){
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.attachment.videosURL.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[0]);
        this.attachment.videos.push(files[0]);
      },
      removeImage(photoIndex){
        this.attachment.galleries.splice(photoIndex, 1);
        this.attachment.galleryURL.splice(photoIndex, 1);
      },
      uploadPics(){
        var GallaryDetails={
          'image':this.attachment.galleries,
          // 'video':this.attachment.videos,
        }
        var formData=new FormData()
        for(var x=0;x<this.attachment.galleries.length;x++){
          formData.append("image"+x,this.attachment.galleries[x])
        }
        formData.append('image_count',this.attachment.galleries.length)
        formData.append('video_count',"0")

        Store.dispatch('gallary/AddGallaryData',formData).then(res=>{
          if(res.status_code==201){
            this.msg="Successfully uploaded"
            this.msgType="success"
          }else{
            this.msg="uploading failed"
            this.msgType="warning"
          }
          this.attachment.galleries=[]
          this.attachment.galleryURL=[]
        }).catch(error=>{
          this.msg="uploading failed"
          this.msgType="warning"
        })
      }



    },
    created(){
      this.msg=''
      var Gallary={
        'file_path':this.Gallary
      }
      Store.dispatch('gallary/getAllGallery').then(res=>{
      }).catch(error=>{
      })
    },
    computed:{
      ...mapState({
        pics:pics => Store.state.gallary.pics,
      })
    }

  };
</script>


<style>
  .ccxesc {
    position: relative;
    width: 50%;
  }

  .image {
    opacity: 1;
    display: block;
    width: 100%;
    height: auto;
    transition: .5s ease;
    backface-visibility: hidden;
  }

  .middle {
    transition: .5s ease;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;
  }

  .ccxesc:hover .image {
    opacity: 0.3;
  }

  .ccxesc:hover .middle {
    opacity: 1;
  }

  .text {
    background-color: #4CAF50;
    color: white;
    font-size: 16px;
    padding: 16px 32px;
  }


  .hover-styl:hover {
    color: #ffffff!important;
    -ms-transform: scale(1.5); /* IE 9 */
    -webkit-transform: scale(1.5); /* Safari 3-8 */
    transform: scale(1.05);
    padding: 10px;
    transition: transform .00000001s;
    box-shadow: 0 10px 33px 4px rgba(1,0,4,0.2), -1px -1px 0px 0 rgba(0, 0, 0, 0.13), 1px 8px 11px 5px rgba(0,0,0,.12)!important;
  }
  /*.dd:hover{*/
  /*-ms-transform: scale(1); !* IE 9 *!*/
  /*-webkit-transform: scale(1.5); !* Safari 3-8 *!*/
  /*transform: scale(1.05);*/
  /*transition: transform 1s;*/
  /*}*/
  .hover-styl:hover .effect {
    display: block;
  }

  .effect {
    padding-top: 7px;
    padding-right: 7px;
    position: absolute;
    right: 0;
    top: 0;
    display: none;
  }
  .effect a {
    color: #000;
  }


  /*.invoice{*/
  /*width: 100%!important;*/
  /*}*/
  /*.invoice-logo{*/
  /*margin: auto;*/
  /*border: 3px solid white;*/
  /*width: 150px !important;*/
  /*height: 150px;*/
  /*border-radius: 50%;*/
  /*-webkit-box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);*/
  /*-moz-box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);*/
  /*box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);*/
  /*background-color: transparent !important;*/
  /*}*/
  /*.layout-invoice-contant{*/
  /*font-size: 12px;*/
  /*font-weight: 600;*/
  /*}*/
  /*.layout-invoice-contant span{*/
  /*padding: 10px 0px 10px 0px;*/

  /*}*/
  /*.layout-invoice-contant .span{*/
  /*border: 1px solid #0097cf;*/
  /*padding-left: 25px;*/
  /*padding-right: 25px;*/

  /*}*/
  /*.invoice .v-dialog:not(.v-dialog--fullscreen){*/
  /*overflow: hidden;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/profile/admin/Media.vue